import imageDe from '../images/de/sensotrend_go_to_kanta.png';
import imageEn from '../images/en/sensotrend_go_to_kanta.png';
import imageEs from '../images/es/sensotrend_go_to_kanta.png';
import imageFi from '../images/fi/sensotrend_go_to_kanta.png';
import imageFr from '../images/fr/sensotrend_go_to_kanta.png';
import imageIt from '../images/it/sensotrend_go_to_kanta.png';
import imageNo from '../images/no/sensotrend_go_to_kanta.png';
import imageSv from '../images/sv/sensotrend_go_to_kanta.png';

export const goToKantaImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
